import useSWR from 'swr';
import { useUserDetails } from '../../../../recoil/hooks/useUserState';
import { getUserAssetsList } from '../../../../services/funds.service';
import { formatNumber } from '../../../../utils/helper';
import { useDarkMode } from '../../../../recoil';

const Funds = ({ isActive }: { isActive: boolean }) => {
  const [darkMode, setDarkMode] = useDarkMode();
  const [user, setUser] = useUserDetails();
  const isUserAuthenticated = user != null || false;
  const { data: userFunds } = useSWR(
    isUserAuthenticated ? ['getUsersAssetFunds'] : null,
    async () => {
      const res = await getUserAssetsList();
      return res;
    },
    {
      revalidateOnFocus: false,
    }
  );
  if (!isActive) return null;

  return (
    <div
      className={`h-full  ${
        darkMode ? 'custom_table_container' : 'custom_table_container_light'
      } text-[#121212] dark:!text-white`}
    >
      <div className="table-responsive">
        <table
          className={`table  custom_table table-hover ${
            darkMode ? 'table-dark' : 'table-light'
          }`}
        >
          <thead>
            <tr>
              <th>Coin</th>
              <th>Total Balance</th>
              <th>Available Balance</th>
              <th>In Order</th>
              <th>USD Value</th>
              {/* <th>Actions</th> */}
            </tr>
          </thead>
          <tbody>
            {userFunds?.data?.assets.map((asset) => (
              <tr
                key={asset.currency}
                className="hover:bg-gray-800 transition-colors"
              >
                <td className="font-medium flex justify-start items-center">
                  <img
                    src={`https://cex.rvaexchange.net/logo?token=${asset.currency}`}
                    alt=""
                    className="mr-2 h-[20px] w-[20px] rounded-full object-cover"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src =
                        'https://via.placeholder.com/20?text=C'; // Fallback to a placeholder
                      e.currentTarget.style.display = 'block'; // Ensure it's visible
                    }}
                  />
                  {asset.currency}
                </td>
                <td>{formatNumber(asset.balance.toString(), 8)}</td>
                <td className="text-green-400">
                  {formatNumber(asset.availableBalance.toString(), 8)}
                </td>
                <td className="text-brand">
                  {formatNumber(asset.holdBalance.toString(), 8)}
                </td>
                <td>${formatNumber(asset.usdWorth.toString(), 2)}</td>
                {/* <td>
                      <div className="flex space-x-2">
                        <button className="bg-blue-600 hover:bg-blue-700 text-white text-xs px-2 py-1 rounded transition-colors">
                          Deposit
                        </button>
                        <button className="bg-green-600 hover:bg-green-700 text-white text-xs px-2 py-1 rounded transition-colors">
                          Transfer
                        </button>
                      </div>
                    </td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Funds;
